
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.311 6.192a.5.5 0 01-.353-.854l2.121-2.121a.5.5 0 11.707.707l-2.121 2.121a.5.5 0 01-.354.147zm2.122 14.74a.5.5 0 01-.354-.147l-2.121-2.121a.5.5 0 01.707-.707l2.121 2.121a.5.5 0 01-.353.854zm-16.866 0a.5.5 0 01-.353-.854l2.121-2.121a.5.5 0 01.707.707l-2.121 2.121a.5.5 0 01-.354.147zm10.846.168H9.587a.5.5 0 010-1h4.826a.5.5 0 110 1zm0 1.9H9.587a.5.5 0 010-1h4.826a.5.5 0 010 1zm-.337-4H10a1.139 1.139 0 01-1.108-.927 20.207 20.207 0 00-1.971-5.053 5.527 5.527 0 011.033-6.288 5.614 5.614 0 016.3-1.269 5.525 5.525 0 013.382 5.407 6.687 6.687 0 01-.711 2.515 18.883 18.883 0 00-1.737 4.7 1.127 1.127 0 01-1.112.915zM12.012 6a4.642 4.642 0 00-3.341 1.43 4.524 4.524 0 00-.856 5.147 20.936 20.936 0 012.056 5.306A.136.136 0 0010 18h4.078a.135.135 0 00.129-.116 19.872 19.872 0 011.827-4.954 5.674 5.674 0 00.6-2.13 4.523 4.523 0 00-2.78-4.42A4.662 4.662 0 0012.012 6zM12 4a.5.5 0 01-.5-.5v-3a.5.5 0 011 0v3a.5.5 0 01-.5.5zm11.5 8.5h-3a.5.5 0 010-1h3a.5.5 0 010 1zM5.688 6.192a.5.5 0 01-.353-.147L3.214 3.924a.5.5 0 01.707-.707l2.121 2.121a.5.5 0 01-.354.854zM3.5 12.5h-3a.5.5 0 010-1h3a.5.5 0 010 1z"}})])
          )
        }
      }
    